import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { createContext, useContext, useMemo, useState } from 'react';

import { LockScreen } from 'hb-react/shared/components/LockScreen';

const ShoppingCardContext = createContext({
  isModalOpen: false,
  toggleModal: () => {},
  closeModal: () => {},
});

export default ShoppingCardContext;

export const useShoppingCardContext = () => useContext(ShoppingCardContext);

export const withShoppingCardContext = (Component) => (props) => {
  const contextValue = useShoppingCardContext();

  return <Component {...props} {...contextValue} />;
};

const predicate = (q) => q.queryKey?.includes('cart');

export const ShoppingCardProvider = ({ children }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const isFetching = useIsFetching({ predicate });
  const isMutating = useIsMutating();

  const isLoading = Boolean(isFetching || isMutating);

  const providerState = useMemo(
    () => ({
      isModalOpen,
      setModalOpen,
      toggleModal: () => setModalOpen((prevState) => !prevState),
      closeModal: () => setModalOpen(false),
    }),
    [isModalOpen],
  );

  return (
    <ShoppingCardContext.Provider value={providerState}>
      {isLoading && <LockScreen />}
      {children}
    </ShoppingCardContext.Provider>
  );
};
